module.exports = __webpack_public_path__ + "static/media/4ème-biennale-des-métiers-dart-Vogüé.1427b6d9.jpg";